var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('canvas',{staticStyle:{"max-width":"700px","margin":"auto"},attrs:{"id":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }